import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import GlobalStyles from "./components/GlobalStyles";
import { PLASTER } from "./theme";

import Home from "./pages/Home";
import ForAgents from "./pages/ForAgents";
import ForBusinesses from "./pages/ForBusinesses";
import Contact from "./pages/Contact";
import GetStarted from "./pages/GetStarted";
import Products from "./pages/Products";
import About from "./pages/About";

function ScrollToTop() {
  // Simple scroll reset on route change
  if (typeof window !== "undefined") {
    window.scrollTo(0, 0);
  }
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <GlobalStyles />
      <div style={{ minHeight: "100vh", background: PLASTER, display: "flex", flexDirection: "column" }}>
        <Nav />
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/for-agents" element={<ForAgents />} />
            <Route path="/for-businesses" element={<ForBusinesses />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/get-started" element={<GetStarted />} />
            <Route path="/products" element={<Products />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
